import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import { Select, Card, Button, Radio, Divider, Input, Upload, AutoComplete } from 'antd';
import Lottie from 'lottie-react';

export const AipaMobileBody = styled.section`
	width: 100%;
	positive: relative;
	font-family: ${({ theme }) => theme.colors.fontInter};
	.logoWrap {
		background: #fff;
		width: 50px;
		height: 50px;
		border-radius: 40px;
		box-shadow: 3px 3px 10px 3px #dddddd;
	}
	.userWrap {
		float: right;
		background: #c0e0e7;
		width: 50px;
		height: 50px;
		border-radius: 40px;
		text-align: center;
		align-items: center;
		padding: 5px;
		overflow: hidden;
		img {
			border-radius: 40px;
			box-shadow: 1px 1px 2px 1px #dddddd;
		}
	}
	@media only screen and (min-width: 992.99px) {
		display: none;
	}
`;
export const XHeader = styled.section`
	width: 100%;
	positive: relative;
	padding: 30px 15px 15px 15px;
`;
export const XTitleHeader = styled.h1`
	margin: 0px;
	width: 100%;
	positive: relative;
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 48px;
	color: #353b3e;
`;
export const XLottieAipaLoader = styled.section`
	width: 100%;
	position: relative;
	margin-top: -15px;
	@media only screen and (min-width: 992.99px) {
		margin-top: 0px;
	}
`;
export const XLottieAipa = styled(Lottie)`
	position: relative;
	background: transparent;
	width: 100%;
`;
export const XDecodexTitle = styled.h1`
	margin: 0px;
	width: 100%;
	position: relative;
	text-align: center;
	font-style: normal;
	font-weight: 500;
	font-size: 40px;
	line-height: 40px;
	letter-spacing: 0.025em;
	text-transform: capitalize;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	font-family: ClashDisplay-Medium !important;
	@media only screen and (min-width: 992.99px) {
		color: ${({ theme }) => theme.CQColors.secondaryColor}!important;
	}
`;
export const ParaDeocdex = styled.p`
	margin: 0px;
	width: 100%;
	position: relative;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 22px;
	text-align: center;
	color: #002141;
	font-family: ${({ theme }) => theme.colors.fontInter};
	@media only screen and (min-width: 992.99px) {
		color: #002141;
	}
`;
export const XSelectIcons = styled(Select)`
	width: 100%;
	position: relative;
	background: transparent;
	@media only screen and (min-width: 992.99px) {
		box-shadow: 0px 0px 15px rgba(0, 114, 153, 0.05);
		height: 50px !important;
	}
	.ant-select-selection-item {
		font-weight: 400 !important;
		font-size: 16px !important;
		line-height: 20px !important;
		color: ${({ theme }) => theme.colors.themeColor1} !important;
		@media only screen and (min-width: 992.99px) {
			font-size: 16px !important;
			line-height: 20px !important;
		}
	}
	.ant-select-selector {
		background-color: rgba(255, 255, 255, 0.3) !important;
		/* box-shadow: 0px 0px 15px rgba(0, 114, 153, 0.05) !important; */
		border-color: rgba(255, 255, 255, 0.3) !important;
	}
	.ant-select-selection-search,
	.ant-select-selector {
		padding-left: 40px !important;
		left: 0px !important;
		border-radius: 20px !important;
		@media only screen and (min-width: 992.99px) {
			background: rgba(255, 255, 255, 0.3) !important;
			border-radius: 15px !important;
		}
	}
`;

export const XAutoCompleteIcons = styled(AutoComplete)`
	width: 100%;
	position: relative;
	background: transparent;
	@media only screen and (min-width: 992.99px) {
		box-shadow: 0px 0px 15px rgba(0, 114, 153, 0.05);
		height: 50px !important;
	}
	.ant-select-selector {
		background-color: rgba(255, 255, 255, 0.3) !important;
		border-color: rgba(255, 255, 255, 0.3) !important;
		padding-left: 40px !important;
		border-radius: 20px !important;
		@media only screen and (min-width: 992.99px) {
			background: rgba(255, 255, 255, 0.3) !important;
			border-radius: 15px !important;
		}
	}
	.ant-select-selection-search {
		padding-left: 40px !important;
		left: 0px !important;
	}
	.ant-select-selection-item {
		font-weight: 400 !important;
		font-size: 16px !important;
		line-height: 20px !important;
		color: ${({ theme }) => theme.colors.themeColor1} !important;
		@media only screen and (min-width: 992.99px) {
			font-size: 16px !important;
			line-height: 20px !important;
		}
	}
	.ant-input {
		background-color: rgba(255, 255, 255, 0.3) !important;
		border-color: rgba(255, 255, 255, 0.3) !important;
		padding-left: 40px !important;
		border-radius: 20px !important;
		font-weight: 400 !important;
		font-size: 16px !important;
		line-height: 20px !important;
		color: ${({ theme }) => theme.colors.themeColor1} !important;
		@media only screen and (min-width: 992.99px) {
			background: rgba(255, 255, 255, 0.3) !important;
			border-radius: 15px !important;
			font-size: 16px !important;
			line-height: 20px !important;
		}
	}
`;
export const AddInputIcon = styled.span`
	position: absolute;
	left: 15px;
	top: 20px;
	transform: translateY(-50%);
	z-index: 999;
	font-size: 16px;
	img {
		max-width: 16px;
		margin-top: -2px;
	}
	@media only screen and (min-width: 992.99px) {
		top: 25px;
		left: 22px;
	}
`;
export const RecordCard = styled(Card)`
	width: 100%;
	position: relative;
	background: rgba(255, 255, 255, 0.3);
	box-shadow: 0px 0px 15px rgba(0, 114, 153, 0.05);
	border-radius: 10px;
	.timmer {
		width: 100%;
		position: relative;
		text-align: center;
		span {
			font-style: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 18px;
			color: #007299;
			background: #ffffff;
			border: 1px solid #007299;
			box-shadow: inset -2px -1px 4px #69eacb;
			border-radius: 3px;
			padding: 3px 10px;
		}
	}
	.actionBtns {
		width: 100%;
		position: relative;
		text-align: center;
	}
`;
export const XActionBtns = styled(Button)`
	// background: rgba(0, 114, 153, 0.8);
	background: ${({ theme }) => theme.CQColors.gradientBg} !important;
	&:disabled {
		background: rgba(0, 114, 153, 0.2) !important;
		svg {
			color: ${({ theme }) => theme.CQColors.white} !important;
		}
	}
	&:hover,
	&:active {
		// background: rgba(0, 114, 153, 0.8) !important;
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
	}
`;
export const XActionPlay = styled(Button)`
	margin: 0px 10px;
	background: ${({ theme }) => theme.CQColors.gradientBg} !important;
	border: none !important;
	min-width: 60px !important;
	min-height: 60px !important;
	box-shadow: 0px 2px 5px ${({ theme }) => theme.CQColors.secondaryColor};
	// &:hover,
	&:hover {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
	}
	&:active {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: #fff !important;
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
	}
	svg {
		font-size: 2rem;
	}
`;
export const XShazaamBtn = styled(Button)`
	margin-left: 0px !important;
	background: ${({ theme }) => theme.CQColors.gradientBg} !important;
	/* box-shadow: 0px 156px 94px rgba(0, 114, 153, 0.05),
		0px 69px 69px rgba(0, 114, 153, 0.1),
		0px 17px 38px rgba(0, 114, 153, 0.1) !important; */
	/* filter: drop-shadow(0px 15px 20px rgba(0, 114, 153, 0.4)) !important; */
	/* backdrop-filter: blur(9px); */
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	border-color: ${({ theme }) => theme.CQColors.white} !important;
	box-shadow: none !important;
	border-radius: 30px !important;
	font-weight: 500 !important;
	font-size: 18px !important;
	line-height: 20px !important;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.CQColors.white};
	height: auto !important;
	padding: 10px 30px !important;
	&:hover,
	&:active {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		border-color: ${({ theme }) => theme.CQColors.white} !important;
	}
`;

export const AipaDesktopBody = styled.section`
	width: 100%;
	position: relative;
	margin-bottom: 15px;
	font-family: ${({ theme }) => theme.colors.fontInter};
	@media only screen and (max-width: 992.99px) {
		display: none;
	}
`;
export const XRadio = styled(Radio)`
	width: 100%;
	position: relative;
	background: rgba(255, 255, 255, 0.3) !important;
	box-shadow: 0px 0px 15px rgba(0, 114, 153, 0.05) !important;
	border-radius: 20px !important;
	border: 1px solid rgba(0, 114, 153, 0.05);
	padding: 15px;
	margin-bottom: 7px;
	color: ${({ theme }) => theme.colors.menu2};
	font-weight: 400;
	font-size: 16px !important;
	line-height: 20px !important;
	&:last-child {
		margin-bottom: 0px;
	}
	span.ant-radio + * {
		padding-left: 10px !important;
	}
	.ant-form-item-control-input {
		min-height: auto !important;
	}
	.ant-radio-checked .ant-radio-inner {
		background: #007299;
		border-color: #007299;
	}
`;
export const XDivider = styled(Divider)`
	width: 100%;
	position: relative;
`;
export const XCardDesktop = styled(Card)`
	width: 100%;
	position: relative;
	height: 100%;
	background: rgba(255, 255, 255, 0.5);
	box-shadow: 0px 0px 15px rgba(0, 114, 153, 0.05);
	border-radius: 10px;
	border: 1px solid rgba(0, 0, 0, 0.1);
	min-height: 385px !important;
	margin-bottom: -24px !important;
	&.bodyPadding .ant-card-body {
		padding: 0px !important;
	}
	&.bodyHeight {
		min-height: auto !important;
	}
	.uploadClinicalDocument {
		height: 385px !important;
	}
	.ant-upload-list-item-file {
		position: relative;
		text-align: center !important;
	}
	.anticon-file {
		position: absolute;
		width: 30px;
		top: 35%;
		left: 0px;
		right: 0px;
		margin: 0px auto;
	}
	.ant-upload-list-item-name {
		position: absolute;
		width: 100%;
		top: 50%;
		left: 0px;
		right: 0px;
		margin: 0px auto;
	}
	p.uploadClinicalDocumentText {
		margin: 0px;
		font-weight: 400;
		font-size: 20px;
		line-height: 24px;
		color: #002141;
		opacity: 0.5;
	}
	.ant-upload-picture-card-wrapper {
		height: 100%;
	}
	.ant-upload-list-picture-card {
		width: 100%;
		position: absolute;
		display: block !important;
		top: 0;
	}
	.ant-upload-list-item-container {
		background: #fff;
		width: 100% !important;
		position: relative;
		margin: 0px !important;
		min-height: 325px !important;
	}
	.timmer {
		width: 100%;
		position: relative;
		text-align: center;
		span {
			font-style: normal;
			font-weight: 500;
			font-size: 26px;
			line-height: 34px;
			color: #007299;
			background: #ffffff;
			border: 1px solid #007299;
			box-shadow: inset -2px -1px 4px #69eacb;
			border-radius: 3px;
			padding: 0px 15px;
		}
	}
	.actionBtns {
		width: 100%;
		position: relative;
		text-align: center;
	}
`;
export const XInputTextArea = styled(Input)`
	width: 100%;
	position: relative;
`;
export const XUpload = styled(Upload)`
	width: 100%;
	position: relative;
`;
